import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    rulesFetchData,
} from './../../actions/AppActions';
import GeneralPopUp from './../GeneralPopUp';
import apiError from './../../constants/api-error';

class Rules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            markup           : <div/>,
            message          : '',
            popupWrapperClass: '',
            iconClass        : '',
            showPopup        : false,
        };
    }

    componentDidMount() {
        this.props.rulesFetchData().then(() => {
            const response = this.props.rulesData;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.getRules[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                const markup = response.Data.Value.body;
                this.setState({markup});
            } else {
                let stateToSet = {
                    message,
                    isToast          : true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass        : 'icon-ucl-warning-icon',
                    showPopup        : true
                };
                this.setState(stateToSet);
            }
        });
    }

    resetToast = () => {
        this.setState({showPopup: false, message: ''});
    };

    render() {
        const {
            message,
            showPopup, popupWrapperClass, iconClass, isToast, markup
        } = this.state;
        const popupProps = {
            showPopup,
            resetToast  : this.resetToast.bind(this),
            message,
            isToast,
            wrapperClass: popupWrapperClass,
            iconClass   : iconClass
        };
        return (<React.Fragment>
            <div className="si-rules">
                <div className="si-container" dangerouslySetInnerHTML={{__html: markup}}/>
            </div>
            <GeneralPopUp {...popupProps}/>
        </React.Fragment>)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        rulesFetchData: () => dispatch(rulesFetchData()),
    };
};
const mapStateToProps = (state) => {
    return {
        trans    : state.appData.trans,
        rulesData: state.appData.rulesData,
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(Rules));


// WEBPACK FOOTER //
// ./src/components/rules/index.js